import type { ReactNode } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { cn } from "@/lib/utils";

export function AppShell({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<SidebarProvider className="h-svh overflow-hidden bg-background">
			<AppSidebar />
			<SidebarInset
				className={cn(
					"h-svh overflow-hidden bg-background flex flex-col",
					className
				)}
			>
				{children}
			</SidebarInset>
		</SidebarProvider>
	);
}

export function PageHeader({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<header
			className={cn(
				"flex h-16 shrink-0 items-center gap-3 border-b bg-background px-6",
				className
			)}
		>
			{children}
		</header>
	);
}
